import React, { useState, useEffect } from "react";
import "./notification-tab.css";

const NotificationTabComponent = ({ 
  accessibleSubjects = [], 
  onTabChange, 
  hasUnsavedChanges, 
  activeSubjectId,
  onCategoryChange,
  activeCategory = "parent_student"
}) => {
  const categories = [
    { id: "parent", label: "Parent" },
    { id: "student", label: "Student" },
    { id: "user_group", label: "User Group" }
  ];

  useEffect(() => {
    const firstAccessible = accessibleSubjects.find((s) => s.isAccessible);
    if (firstAccessible && !activeSubjectId) {
      onTabChange(firstAccessible.subject_id);
    }
  }, [accessibleSubjects, activeSubjectId, onTabChange]);

  const handleTabClick = (subject) => {
    if (!subject.isAccessible) return;
    if (hasUnsavedChanges && subject.subject_id !== activeSubjectId) {
      onTabChange(null, subject.subject_id);
    } else {
      onTabChange(subject.subject_id);
    }
  };

  const handleCategoryChange = (categoryId) => {
    if (hasUnsavedChanges) {
      onCategoryChange(null, categoryId);
    } else {
      onCategoryChange(categoryId);
    }
  };

  return (
    <div className="notification-tab-container">
      <div className="notification-category-tabs">
        <div className="tab-buttons category-buttons">
          {categories.map((category) => (
            <button
              key={category.id}
              className={`tab-button category-tab ${
                category.id === activeCategory ? "active" : ""
              }`}
              onClick={() => handleCategoryChange(category.id)}
            >
              {category.label.toUpperCase()}
            </button>
          ))}
        </div>
      </div>
      {/* <div className="notification-subject-tabs">
        <div className="tab-buttons subject-buttons">
          {accessibleSubjects.map((subject) => (
            <button
              key={subject.subject_id}
              className={`tab-button subject-tab
                ${subject.subject_id === activeSubjectId ? "active" : ""} 
                ${!subject.isAccessible ? "disabled" : ""}`}
              onClick={() => handleTabClick(subject)}
              disabled={!subject.isAccessible}
            >
              {subject.subject_name.toUpperCase()}
            </button>
          ))}
        </div>
      </div> */}
    </div>
  );
};

export default NotificationTabComponent;